export default __webpack_public_path__ + "static/media/sidebar_logo.9a72f057.png";